var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(!_vm.hideBuildId)?_c('span',{staticClass:"absolute bottom-0 right-0"},[_vm._v(_vm._s(_vm.buildId))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }